@let isLoading = loading$ | async;
<div tabindex="0" class="market-layout" (mouseenter)="isActive = true" (mouseleave)="isActive = false">
  @if (!isLoading) {
    <app-event-header [eventItem]="eventItem" />
    @if (marketOps.allMarkets$ | async; as allMarkets) {
      @if (eventItem) {
        <div class="nav-container">
          <mat-icon class="scroll-left" (click)="scrollNav(-200)">chevron_left</mat-icon>
          <div class="market-nav" [ngClass]="{ 'racing-nav': isRacing }">
            @for (nav of marketTabs; track nav; let i = $index) {
              @let isRacingLabel = racingTabLabels?.[nav];
              @let id = isRacingLabel ? "m_" + nav.replace(".", "_") : nav;
              <button
                [id]="id"
                tabindex="-1"
                [disabled]="isLoading"
                (click)="handleTabSelection(nav)"
                [ngClass]="{
                  'bg-secondary border-primary-2 active-tab text-primary': activeTab === nav,
                  'border-secondary-2': activeTab !== nav,
                }"
                [routerLink]="
                  isRacingLabel
                    ? null
                    : [
                        '/app/main',
                        {
                          outlets: {
                            navigation: ['event', eventItem?.event?.id],
                            content: ['event-markets', eventItem?.event?.id],
                          },
                        },
                      ]
                "
                class="btn-market-nav">
                <span>{{ isRacingLabel ? racingTabLabels?.[nav] : nav }}</span>
              </button>
            }
          </div>
          <mat-icon class="scroll-right" (click)="scrollNav(200)">chevron_right</mat-icon>
        </div>
      }
      @if (allMarkets.length > 0 && eventItem) {
        @if (marketOps.singleMarketSelected && !isRacing) {
          <router-outlet />
        } @else {
          <div class="markets">
            <mat-accordion multi="true">
              @for (market of allMarkets; track marketOps.marketTracker(market)) {
                @if (market?.isBookmaker || market?.isMOddsBookmaker) {
                  <app-bookmaker [market]="market" [openDate]="eventItem?.event?.openDate" />
                } @else if (market?.isFancy) {
                  <app-fancy-market [market]="market" [openDate]="eventItem?.event?.openDate" />
                } @else {
                  <app-market [data]="market" />
                }
              }
            </mat-accordion>
          </div>
        }
      }

      @if (!isLoading && !isLoadingStatus() && allMarkets.length === 0) {
        <app-alert
          [config]="{
            title: 'No Markets Found',
            subtitle: 'There are currently no markets available in this section.',
            type: 'info',
          }" />
      }
    }
  }
  <app-e-markets-loader [show]="(loading$ | async) || isLoadingStatus()" />
</div>
